import { render, staticRenderFns } from "./DriveFile.vue?vue&type=template&id=0069c24d&scoped=true&lang=pug"
import script from "./DriveFile.vue?vue&type=script&lang=js"
export * from "./DriveFile.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0069c24d",
  null
  
)

export default component.exports